import { Component, OnInit, OnDestroy, Input, EventEmitter, Output, ElementRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { combineLatest, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PolicyState } from '../store/policy/policy.reducer';
import { TableCardLayoutComponent } from '../shared/table-card-layout/table-card-layout.component';
import { globalMessages } from 'src/app/shared/global-messages';
import { PSIC_COMPONENTS } from '@pacificspecialtyinsurancecompany/psic-ng-components';

interface Transaction {
    reasonCode: string;
    reasonDescription: string;
    description: string;
    nextStep: string;
    nextActionDate: string;
    loggedOff: boolean;
    loggedOffDate: string;
}

@Component({
    selector: 'app-transactions-information',
    standalone: true,
    imports: [CommonModule, TableCardLayoutComponent, ...PSIC_COMPONENTS],
    templateUrl: './transactions-information.component.html',
    styleUrl: './transactions-information.component.scss',
})
export class TransactionsInformationComponent implements OnInit, OnDestroy {
    @Input() isDCPolicyLoaded = false;
    @Input() dcPolicyFailed = false;
    @Output() retry = new EventEmitter<void>();
    allTransactions: Transaction[] = [];
    transactions: Transaction[] = [];
    showAll = false;
    private readonly PAGE_SIZE = 5;
    isActive = false;
    private subscription!: Subscription;
    private el = inject(ElementRef);
    globalMessages = globalMessages;

    constructor(private store: Store<{ policy: PolicyState }>) {}

    ngOnInit() {
        this.subscription = combineLatest([
            this.store.select((state) => state.policy.data).pipe(filter((data) => !!data)),
            this.store.select((state) => state.policy.policyNumber).pipe(filter((policyNumber) => !!policyNumber)),
        ]).subscribe(([policyData, policyNumber]) => {
            const transactionsData = policyData[policyNumber!]?.policySnapshot?.transactionInformation || [];
            this.allTransactions = transactionsData.map((t: any) => ({
                reasonCode: t.reasonCode?.value || '',
                reasonDescription: t.description?.value || '',
                description: t.reasonDescription?.value || '',
                nextStep: t.nextStep?.value || '',
                nextActionDate: t.nextActionDate?.value || '',
                loggedOff: t.loggedOff?.value || false,
                loggedOffDate: t.loggedOffDate?.value || '',
            }));
            this.showAll = false;
            this.transactions = this.allTransactions.slice(0, this.PAGE_SIZE);
        });
    }

    loadMore() {
        this.showAll = true;
        this.transactions = [...this.allTransactions];
    }

    showLess() {
        this.showAll = false;
        this.transactions = this.allTransactions.slice(0, this.PAGE_SIZE);
        this.el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    getLoggedOffDate(transaction: Transaction): string {
        if (!transaction.loggedOff) {
            return '-----';
        }
        return transaction.loggedOffDate;
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

    retryDCPolicy() {
        this.retry.emit();
    }
}
